import { Select } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { notifyError } from '../store/utils';
import { API } from '../api';

interface DeliveryManSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void;
  onSelect?: (customer: any) => void;
}

const DeliveryManSelect: React.FC<DeliveryManSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  onChange,
  onSelect,
}) => {
  const hasRun = useRef(false);
  const [state, updateState] = useState<any[]>([]);

  const onSearch = useCallback(async (query: string) => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/member/branch/delivery-man?page=1&size=10&query=${query}`
      );
      updateState(result?.data || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const loadFirst = useCallback(async () => {
    try {
      let url = `/member/branch/delivery-man?page=1&size=10`;
      if (value) {
        url = `/member/branch/delivery-man?page=1&size=10&required=${value}`;
      }
      const { result } = await API.get({ apiVersion: 'api' })(url);
      const list = result?.data || [];
      updateState(list);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [value]);

  const changeHandler = useCallback(
    (value: string) => {
      const item = state.find((it: any) => it?.no === value);
      if (onChange) onChange(value);
      if (onSelect) onSelect(item);
    },
    [state, onSelect, onChange]
  );

  useEffect(() => {
    if (value !== undefined && !hasRun.current) {
      loadFirst();
      hasRun.current = true;
    }
  }, [value, loadFirst]);

  useEffect(() => {
    loadFirst();
  }, []);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.firstName,
        value: `${item.no}`,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Хүргэгч сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      onSearch={(query: string) => onSearch(query)}
      onChange={changeHandler}
      options={options}
      disabled={disabled}
      value={value}
      filterOption={false}
    />
  );
};

export default DeliveryManSelect;
